'use strict';

var actions = require('./actions.js');

var analyticsModule = {
  name: 'PicoAnalyticsModule',
  creators: actions.creators,
  types: actions.types
};

module.exports = analyticsModule;
//# sourceMappingURL=index.js.map
